module.exports = __webpack_public_path__ + "static/media/about-rpg.20fbad35.svg";